import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface IconProps {
    handleClose: () => void;
    disabled?: boolean;
}

function DialogCloseButton({ handleClose, disabled }: IconProps ) {

    return (
        <IconButton
            disabled={disabled}
            aria-label="close"
            onClick={handleClose}
            size="small"
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
            }}
        >
            <CloseIcon />
        </IconButton>
    )
}

export default DialogCloseButton;